import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  constructor(private router: Router) {}

  routerDelete() {
    window.scrollTo(0, 0);
    this.router.navigate(['/delete-account']);
  }

  routerTerm() {
    window.scrollTo(0, 0);
    this.router.navigate(['/terms-conditions']);
  }

  routerPrivacy() {
    window.scrollTo(0, 0);
    this.router.navigate(['/privacy-policy']);
  }

  scrollToTestimonials(event: Event) {
    event.preventDefault();
    const el = document.getElementById('testimonials');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
